module.exports = __webpack_public_path__ + "img/symbol_4.049f006c.png";